(() => {
  if (customElements.get('go-withdrawal-preview')) return;
  customElements.define('go-withdrawal-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('[data-withdrawal-form]');
      const delivery = this.querySelector('#go-withdrawal-delivery');
      if (!dialog || !form || !delivery) return;
      const entry = form.querySelector('[data-entry]');
      const review = form.querySelector('[data-review]');
      const result = form.querySelector('[data-result]');
      const confirm = form.querySelector('[data-confirm]');
      const itemsLabel = form.querySelector('[data-items-label]');
      const items = form.elements.namedItem('items');
      const storageKey = 'go-withdrawal-reference';
      const declaration = 'Je vous notifie ma decision de me retracter de mon achat pour les articles ci-dessus.';
      let opener, previousOverflow, reviewed;
      let escapeOwned = false;
      let submitting = false;
      const trim = name => form.elements.namedItem(name).value.trim();
      const storage = {
        get() { try { return sessionStorage.getItem(storageKey); } catch { return null; } },
        set(value) { try { sessionStorage.setItem(storageKey, value); } catch {} },
        clear() { try { sessionStorage.removeItem(storageKey); } catch {} },
      };
      const open = () => {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      };
      const showResult = (title, text, reference = '') => {
        entry.hidden = true;
        review.hidden = true;
        result.hidden = false;
        result.querySelector('h3').textContent = title;
        result.querySelector('[data-result-message]').textContent = text;
        result.querySelector('[data-result-reference]').textContent = reference ? `Reference : ${reference}` : '';
        if (!dialog.open) open();
        result.querySelector('h3').focus();
        dialog.scrollTop = 0;
      };
      const reset = () => {
        form.reset();
        items.disabled = true;
        items.required = false;
        itemsLabel.hidden = true;
        entry.hidden = false;
        review.hidden = true;
        result.hidden = true;
        confirm.disabled = false;
        reviewed = null;
      };
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !dialog.open) return;
        escapeOwned = true;
        event.preventDefault();
        event.stopPropagation();
        dialog.close();
      }, { ...options, capture: true });
      document.addEventListener('keyup', event => {
        if (event.key !== 'Escape' || !escapeOwned) return;
        escapeOwned = false;
        event.preventDefault();
        event.stopPropagation();
      }, options);
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-go-withdrawal-open]');
        if (!link || link.getAttribute('href') !== `#${dialog.id}`) return;
        event.preventDefault();
        if (dialog.open) return;
        opener = link;
        if (submitting) {
          showResult('Envoi en cours de v\u00e9rification', 'Terminez le contr\u00f4le de s\u00e9curit\u00e9. Si l\'envoi reste bloqu\u00e9, contactez contact@goautoradio-gps.fr en indiquant la r\u00e9f\u00e9rence ci-dessous.', storage.get());
          return;
        }
        reset();
        open();
        form.elements.namedItem('firstName').focus();
      }, options);
      dialog.querySelectorAll('[data-close]').forEach(button => {
        button.addEventListener('click', () => dialog.close(), options);
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow ?? '';
        if (!submitting) reset();
        opener?.focus();
      }, options);
      form.addEventListener('change', () => {
        const partial = form.elements.namedItem('scope').value === 'partial';
        itemsLabel.hidden = !partial;
        items.disabled = !partial;
        items.required = partial;
      }, options);
      form.addEventListener('input', event => {
        event.target.setCustomValidity?.('');
      }, options);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (entry.hidden || submitting) return;
        for (const input of form.querySelectorAll('input[required], textarea[required]')) {
          input.setCustomValidity(input.value.trim() ? '' : 'Veuillez remplir ce champ.');
        }
        const email = trim('email').toLowerCase();
        form.elements.namedItem('email').setCustomValidity(/^[^\s@<>;,"\\]+@[^\s@<>;,"\\]+\.[^\s@<>;,"\\]+$/.test(email) ? '' : 'Indiquez une seule adresse e-mail valide.');
        if (!form.reportValidity()) return;
        reviewed = Object.freeze({
          firstName: trim('firstName'), lastName: trim('lastName'), email,
          order: trim('order'), scope: form.elements.namedItem('scope').value,
          items: form.elements.namedItem('scope').value === 'partial' ? trim('items') : 'Toute la commande',
        });
        const summary = { name: `${reviewed.firstName} ${reviewed.lastName}`, order: reviewed.order, items: reviewed.items, email: reviewed.email };
        for (const [key, value] of Object.entries(summary)) form.querySelector(`[data-summary="${key}"]`).textContent = value;
        entry.hidden = true;
        review.hidden = false;
        review.querySelector('h3').focus();
        dialog.scrollTop = 0;
      }, options);
      form.querySelector('[data-back]').addEventListener('click', () => {
        if (submitting) return;
        reviewed = null;
        review.hidden = true;
        entry.hidden = false;
        form.elements.namedItem('firstName').focus();
      }, options);
      delivery.addEventListener('submit', event => {
        if (!submitting || !delivery.querySelector('[data-delivery-body]').value) event.preventDefault();
      }, options);
      confirm.addEventListener('click', () => {
        if (submitting || !reviewed || review.hidden) return;
        if (!crypto.randomUUID || !window.Shopify?.captcha?.protect) {
          showResult('Envoi indisponible', 'Le contr\u00f4le de s\u00e9curit\u00e9 n\'est pas pr\u00eat. Rechargez la page ou adressez votre d\u00e9claration \u00e0 contact@goautoradio-gps.fr. Aucun message n\'a \u00e9t\u00e9 envoy\u00e9 par ce formulaire.');
          return;
        }
        const reference = `RET-${crypto.randomUUID()}`;
        const payload = { version: 1, mode: 'PROD', reference, ...reviewed, confirmed: true, declaration };
        const bytes = new TextEncoder().encode(JSON.stringify(payload));
        const envelope = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
        delivery.querySelector('[data-delivery-body]').value = [
          'Declaration de retractation confirmee depuis le formulaire GoAutoradio.',
          'GOAUTORADIO_RETRACTATION_V1_PROD',
          `GO_PAYLOAD_START:${envelope}:GO_PAYLOAD_END`,
          `Reference : ${reference}`, `Nom : ${reviewed.firstName} ${reviewed.lastName}`,
          `Commande ou reference : ${reviewed.order}`, `Articles : ${reviewed.items}`,
          `Email : ${reviewed.email}`, `Declaration confirmee : ${declaration}`,
        ].join('\n');
        delivery.elements.namedItem('contact[email]').value = reviewed.email;
        delivery.elements.namedItem('contact[name]').value = `${reviewed.firstName} ${reviewed.lastName}`;
        submitting = true;
        confirm.disabled = true;
        storage.set(reference); // Only the random reference is stored, never customer fields.
        dialog.close(); // Shopify's CAPTCHA must remain accessible outside the modal layer.
        window.Shopify.captcha.protect(delivery, () => delivery.requestSubmit());
      }, options);
      const pending = storage.get();
      if (pending && /^RET-[a-f0-9-]{36}$/.test(pending)) {
        if (delivery.querySelector('[data-delivery-success]')) {
          storage.clear();
          showResult('D\u00e9claration transmise', 'Votre d\u00e9claration a \u00e9t\u00e9 transmise. Un accus\u00e9 de r\u00e9ception vous sera adress\u00e9 par e-mail. Conservez cette r\u00e9f\u00e9rence ; si vous ne recevez pas l\'e-mail, contactez contact@goautoradio-gps.fr.', pending);
        } else if (delivery.querySelector('[data-delivery-errors]')) {
          storage.clear();
          showResult('Envoi non confirm\u00e9', 'Une erreur emp\u00eache de confirmer l\'envoi. Adressez votre d\u00e9claration \u00e0 contact@goautoradio-gps.fr en indiquant cette r\u00e9f\u00e9rence.', pending);
        }
      }
      this.cleanup = () => {
        if (dialog.open) {
          dialog.close();
          document.documentElement.style.overflow = previousOverflow ?? '';
        }
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.controller?.abort();
    }
  });
})();
